import ReactGA from 'react-ga4';
import { getState } from 'library/local-storage';
export var analytics = {
    event: function (action, label, value) {
        var _a, _b;
        if (label === void 0) { label = null; }
        if (value === void 0) { value = null; }
        var category = ((_b = (_a = getState()) === null || _a === void 0 ? void 0 : _a.game) === null || _b === void 0 ? void 0 : _b.name) || 'unknown';
        var eventParams = { action: action, category: category };
        if (label !== null)
            eventParams.label = label;
        if (typeof value === 'number')
            eventParams.value = value;
        ReactGA.event(eventParams);
    },
};
